import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { handleLogin } from '../logic/utils';
const Login = () => {
    const [webId, setWebId] = useState('');
    const loginEventHandler = (event) => {
        event.preventDefault();
        handleLogin(webId).catch(() => alert('Login failed!'));
    };
    return (_jsxs("form", { className: "grid grid-cols-3 gap-2 mb-auto", children: [_jsx("p", { className: 'col-span-3', children: "You are not logged in. Login with webID:" }), _jsx("input", { className: "col-span-2 todo-input-text", type: "text", placeholder: "webID", value: webId, onChange: (event) => setWebId(event.target.value) }), _jsx("input", { type: "submit", className: "todo-input-button", value: "Login", onClick: loginEventHandler })] }));
};
export default Login;
